import { render, staticRenderFns } from "./MiscellaneousWrapper.vue?vue&type=template&id=8901268e&"
import script from "./MiscellaneousWrapper.vue?vue&type=script&lang=js&"
export * from "./MiscellaneousWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports